// Status colours for schedule cells — used by grids, chips and the legend.
// Cost: calculated but display hidden in v1 (hourlyRate kept on roster).
export const statusColors = {
  available: { bg: '#e7f5ec', fg: '#1e7a46', dot: '#2e9e5b' },
  partial:   { bg: '#fdf3da', fg: '#9a6a12', dot: '#e0a728' },
  full:      { bg: '#1f5f9e', fg: '#ffffff', dot: '#1f5f9e' },
  off:       { bg: '#f3f5f8', fg: '#9aa4b2', dot: '#c2cad6' },
  over:      { bg: '#fbe4e2', fg: '#b3261e', dot: '#d32f2f' },
  exception: { bg: '#f3e8fd', fg: '#7c3aed', dot: '#9d5ce0' },
}
